import _ from 'lodash';

export const trendLineConfig = {
  'stroke-dasharray': '6,6',
  'stroke-width': 2,
  zIndex: 900,
  dashStyle: 'dash',
  id: 'trendLine',
};

export const cumulativeLineConfig = {
  'stroke-dasharray': '6,6',
  'stroke-width': 2,
  zIndex: 900,
  dashStyle: 'dash',
  id: 'cumulative',
};

/**
 * Расчет линии тренда методом регресии.
 * Для расчета линии регресси необходимо составить линейное уравнение вида: Y=coefficientA + coefficientB * X
 * @param data все значения по оси Y на графике. Ось X состоит из индексов элементов оси Y.
 * @param average среднее значение по оси Y.
 * @returns {{min: *, max: *}} объект, значения которого получены из уровнения, где для значения min высчитываться y
 * c минимальным значением x, а для max соответственно с максимальным значением x.
 */
export const trendLine = (data, average) => {
  // переменная служит для того, чтобы было понятно, что это значение по оси Oy
  const averageY = average;
  // для увеличения производительности, чтобы не считать сумму последовательных чисел, подсчет среднего для оси Ox,
  // происходит путем подсчета арифмитической прогрессии(которая начинается с 1 до data.length) для получения суммы
  // чисел, а затем происходит деление на количество.
  const averageX = ((1 + data.length) * data.length) / 2 / data.length;

  // арифмитическая прогрессия квадратов значений оси Ox
  let axeX = 0;
  // перемноженные значения графика X*Y
  let multVal = 0;
  for (let i = 1; i <= data.length; i++) {
    axeX += i ** 2;
    multVal += data[i - 1] * i;
  }

  const coefficientB = _.round(
    (multVal - data.length * averageX * averageY) / (axeX - data.length * averageX * averageX),
    2
  );
  const coefficientA = _.round(averageY - coefficientB * averageX, 2);

  return {
    min: coefficientA + coefficientB * 1,
    max: coefficientA + coefficientB * data.length,
  };
};
